import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var TickOutline = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 20a2.978 2.978 0 01-2.121-.879l-4-4C4.312 14.555 4 13.801 4 13s.312-1.555.879-2.122c1.133-1.133 3.109-1.133 4.242 0l1.188 1.188 3.069-5.523a2.999 2.999 0 015.507.632 2.975 2.975 0 01-.263 2.282l-5 9A3.015 3.015 0 0111 20zm-4-8c-.268 0-.518.104-.707.293S6 12.732 6 13s.104.518.293.707l4 4a1.002 1.002 0 001.581-.221l5-9a.993.993 0 00.088-.76.992.992 0 00-.478-.6 1.015 1.015 0 00-1.357.388l-4.357 7.841-3.062-3.062A.996.996 0 007 12z"
  }));
});
TickOutline.displayName = 'TickOutline';
export var TickOutlineDimensions = {
  height: 24,
  width: 24
};